import Links from '@/shared/constants/navegacao';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { Link } from 'react-router-dom';
import { ReadAtuacaoDto } from '@/api.types';
import { readAtuacao } from '@/modules/business/atuacao/atuacao.service';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useEffect, useState } from 'react';

export default function AtuacoesIndexPage() {
  const { setActions } = useBreadcrumbActions();
  const [registros, setRegistros] = useState<[ReadAtuacaoDto[], number]>();
  const tableState = useDataTableState('nome');

  const handleBuscar = () => {
    readAtuacao({
      skip: (tableState.currentPage - 1) * tableState.pageSize,
      take: tableState.pageSize,
      orderBy: "ASC",
      comVaras: true
    })
      .then((result) => {
        setRegistros(result);
      })
      .catch((res) => {
        toast.error(String(res) || '');
      });
  };

  useEffect(() => {
    handleBuscar();
  }, []);

  useEffect(() => {
    setActions({ primary: { label: 'Cadastrar', href: Links.Atuacoes_Criar, onClick: () => { } } });
    return () => setActions({});
  }, [setActions]);

  let colunas: Column<ReadAtuacaoDto>[] = [
    { key: "ordem", header: "Ordem" },
    { key: "nome", header: "Atuação" },
    {
      key: "varas", header: "Varas",
      render: (row) => {
        return (<>{row.varas?.length}</>)
      }
    },
    {
      key: "acoes", header: "Ações", render: (row) =>
        <Link className="link-secondary" to={Links.Atuacoes_Editar + '/' + row.id}>
          Editar
        </Link>
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3>Esferas de Atuação</h3>
          <span className="blockquote-footer pb-4 text-end">
            Tipos de atuações de varas.
          </span>
        </div>
        <hr className="pb-4" />
        {registros &&
          <DataTable
            columns={colunas}
            data={registros[0]}
            initialSortKey='nome'
            onChange={handleBuscar}
            serverSide={true}
            states={tableState}
            totalRecords={registros[1]}
          />
        }
      </div>
    </>
  );
}
